import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation();

  return (
    <div className="container page">
      <h1 className="page-title">{t('about.title')}</h1>
      <div className="page-body">
        <p>{t('about.p1')}</p>
        <p>{t('about.p2')}</p>
      </div>
    </div>
  );
}

export default About;
